module.exports = __webpack_public_path__ + "static/media/everyday_digital.b64ff439.png";